import { __read } from "tslib";
import React from 'react';
import { useInView } from './hooks';
import { browser } from './utils';
export var WidthDetectorObserver = React.memo(function (_a) {
    var setWidth = _a.setWidth;
    var supportsResizeObserver = browser.supportsResizeObserver;
    var _b = __read(useInView({
        /* Optional options */
        threshold: 0,
    }), 3), inViewRef = _b[0], inView = _b[1], target = _b[2];
    var observer = React.useRef(function () {
        if (typeof window === 'undefined' || !supportsResizeObserver) {
            return null;
        }
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function (entries) {
            if (!Array.isArray(entries) || !entries.length) {
                return;
            }
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    React.useEffect(function () {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) {
            return;
        }
        if (target) {
            if (inView) {
                resizeObserver.observe(target);
            }
            else {
                resizeObserver.unobserve(target);
            }
        }
        return function () {
            resizeObserver.disconnect();
        };
    }, [target, inView]);
    return (React.createElement("div", { style: {
            display: 'block',
            width: '100%',
            position: 'absolute',
        }, ref: inViewRef }));
});
//# sourceMappingURL=width-detector-observer.js.map